import { url } from '@finance/url';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var DOMAIN_ENV;

(function (DOMAIN_ENV) {
  DOMAIN_ENV["LOCAL"] = "local";
  DOMAIN_ENV["DEV"] = "dev";
  DOMAIN_ENV["TEST"] = "test";
  DOMAIN_ENV["UAT"] = "uat";
  DOMAIN_ENV["PROD"] = "prod";
  DOMAIN_ENV["OUTER_PROD"] = "outer_prod";
})(DOMAIN_ENV || (DOMAIN_ENV = {}));

var Domain =
/*#__PURE__*/
function () {
  /**
   * @param {string} domain 域名
   * @param {string} env 环境，仅供单元测试用
   */
  function Domain() {
    var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : url('domain');
    var env = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, Domain);

    this.env = env;
    this.domain = domain;
    this.ip = '';
    this.domainUrl = {
      res: '',
      api: '',
      actapi: '',
      mkt: '',
      pc: '',
      collect: '',
      loan: ''
    };
    this.init();
  }

  _createClass(Domain, [{
    key: "init",
    value: function init() {
      var env = this.env;
      var domainUrlConfig;

      if (!env) {
        var hostname = location.hostname;
        var isOuterProd = /^tg/.test(hostname);
        var isProd = /^marketres/.test(hostname);
        var isUat = /^lcuatres/.test(hostname);
        var isTest = /^lctsres/.test(hostname);
        var isDev = /^devpub/.test(hostname);
        /* istanbul ignore next */

        if (isOuterProd) {
          env = DOMAIN_ENV.OUTER_PROD;
        } else if (isProd) {
          env = DOMAIN_ENV.PROD;
        } else if (isUat) {
          env = DOMAIN_ENV.UAT;
          domainUrlConfig = {
            uat: /^lcuatres(\d*)\./.exec(hostname)[1]
          };
        } else if (isTest) {
          env = DOMAIN_ENV.TEST;
          domainUrlConfig = {
            test: /^lctsres(\d+)\./.exec(hostname)[1]
          };
        } else if (isDev) {
          env = DOMAIN_ENV.DEV;
        } else {
          if (/^localhost/.test(hostname)) {
            this.ip = 'localhost';
          } else if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(hostname)) {
            this.ip = hostname;
          } else {
            console.warn('@common/domain：未知的环境！');
          }

          env = DOMAIN_ENV.LOCAL;
        }

        this.env = env;
      }

      this.setDomainUrl(this.getDomainUrl(env, domainUrlConfig));
    }
  }, {
    key: "getDomainUrl",
    value: function getDomainUrl(env) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        test: '1',
        uat: ''
      };

      switch (env) {
        case DOMAIN_ENV.OUTER_PROD:
          return {
            res: "https://tg.".concat(this.domain),
            api: "https://moneymarket.".concat(this.domain),
            actapi: "https://act.".concat(this.domain),
            mkt: "https://moneymarket.".concat(this.domain),
            pc: "https://8.".concat(this.domain),
            collect: "https://dataapi.".concat(this.domain),
            loan: "https://sxd.".concat(this.domain)
          };

        case DOMAIN_ENV.PROD:
          return {
            res: "https://marketres.".concat(this.domain),
            api: "https://moneymarket.".concat(this.domain),
            actapi: "https://act.".concat(this.domain),
            mkt: "https://moneymarket.".concat(this.domain),
            pc: "https://8.".concat(this.domain),
            collect: "https://dataapi.".concat(this.domain),
            loan: "https://sxd.".concat(this.domain)
          };

        case DOMAIN_ENV.UAT:
          return {
            res: "https://lcuatres".concat(options.uat, ".").concat(this.domain),
            api: "https://lcuat".concat(options.uat, ".").concat(this.domain),
            actapi: "https://actuat.".concat(this.domain),
            mkt: "https://lcuat.".concat(this.domain),
            pc: "https://lcuatweb.".concat(this.domain, "/market-mobi"),
            collect: "https://dataapi.".concat(this.domain),
            loan: "https://lcuat".concat(options.uat, ".").concat(this.domain)
          };

        case DOMAIN_ENV.TEST:
          return {
            res: "https://lctsres".concat(options.test, ".").concat(this.domain),
            api: "https://lcts".concat(options.test, ".").concat(this.domain),
            actapi: "https://act".concat(options.test, ".").concat(this.domain),
            mkt: "https://lcts".concat(options.test, ".").concat(this.domain),
            pc: "https://lcts".concat(options.test, ".").concat(this.domain, "/p2pmarket"),
            collect: "https://lcts5.".concat(this.domain),
            loan: "https://lcts".concat(options.test, ".").concat(this.domain)
          };

        case DOMAIN_ENV.DEV:
          return {
            res: "https://devpub.".concat(this.domain),
            api: "https://devpub.".concat(this.domain),
            actapi: "https://act.".concat(this.domain),
            mkt: "https://devpub.".concat(this.domain),
            pc: "https://devpcweb.".concat(this.domain, "/p2pmarket"),
            collect: "https://lcts5.".concat(this.domain),
            loan: "https://devpub.".concat(this.domain)
          };

        case DOMAIN_ENV.LOCAL:
          return {
            res: "http://".concat(this.ip),
            api: "http://".concat(this.ip, ":8090"),
            actapi: "http://".concat(this.ip, ":8090"),
            mkt: "http://".concat(this.ip),
            pc: 'https://8.ssjlicai.com',
            collect: "http://".concat(this.ip, ":8090"),
            loan: "http://".concat(this.ip, ":8090")
          };
      }
    }
  }, {
    key: "setDomainUrl",
    value: function setDomainUrl(domainUrl) {
      var _this = this;

      Object.keys(this.domainUrl).forEach(function (item) {
        if (domainUrl[item] !== undefined) {
          _this.domainUrl[item] = domainUrl[item];
        }
      });
    }
  }, {
    key: "setDomain",
    value: function setDomain(domain) {
      var _this2 = this;

      var tmpDomain = this.domain;
      this.domain = domain;
      Object.keys(this.domainUrl).forEach(function (item) {
        _this2.domainUrl[item] = _this2.domainUrl[item].replace(tmpDomain, domain);
      });
    }
    /**
     * 手动设置当前环境，仅供单元测试用
     *
     * @param {string} env
     * @memberof Domain
     */

  }, {
    key: "setDomainEnv",
    value: function setDomainEnv(env) {
      this.env = env;
      this.domain = 'ssjlicai.com';

      if (env === DOMAIN_ENV.LOCAL) {
        this.ip = '1.2.3.4';
      }

      this.init();
    }
  }]);

  return Domain;
}();

var domainInstance = null;
var getInstance = function getInstance() {
  if (!domainInstance) {
    domainInstance = new Domain();
  }

  return domainInstance;
}; // 自定义hostname

var setHostName = function setHostName(host) {
  getInstance().setDomain(host);
}; // 设置所有的hostname

var setAllHostName = function setAllHostName(hostMap) {
  getInstance().setDomainUrl(hostMap);
};
var domain = getInstance().domainUrl;

export { DOMAIN_ENV, getInstance, setHostName, setAllHostName, domain };
